import { ArrowUpRight, GitCompareArrows } from 'lucide-react'
import { createContext, type ReactNode, useContext, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

const ReviewNavigation = createContext<{ request: number; show: () => void } | null>(null)

export function ProposalReviewNavigation({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState(0)
  const navigation = useMemo(
    () => ({ request, show: () => setRequest(value => value + 1) }),
    [request]
  )
  return <ReviewNavigation.Provider value={navigation}>{children}</ReviewNavigation.Provider>
}

export function useProposalReviewNavigation() {
  return useContext(ReviewNavigation)
}

/** A signpost, not a second review surface. Especially useful when the review
 * and conversation stack on a narrow screen. */
export function ProposalReadyNotice() {
  const { t } = useTranslation()
  const navigation = useProposalReviewNavigation()
  return (
    <div className="flex max-md:flex-wrap shrink-0 items-center gap-3 border-b bg-primary/5 px-4 py-3">
      <GitCompareArrows className="size-4 shrink-0 text-primary" aria-hidden />
      <p role="status" className="min-w-0 max-md:min-w-40 flex-1 text-xs text-muted-foreground">
        {t('schemaAgent.workbench.reviewReady')}
      </p>
      {navigation && (
        <Button variant="outline" size="sm" onClick={navigation.show}>
          {t('schemaAgent.workbench.reviewChanges')}
          <ArrowUpRight className="size-3.5" aria-hidden />
        </Button>
      )}
    </div>
  )
}
